'use strict';

import { hostFactory as hostInstance } from "@api/factory";

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[api::registrations]';

const launch = registrationId =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.get(`/api/records/registrations/${registrationId}/launch`);
}

export default {
  launch
};